import { createContext } from "react";

const RecordContext = createContext([]);
const ParticularContext = createContext([]);
const RefreshTrigger = createContext();
const OpenTrigger = createContext();
export { RecordContext, ParticularContext, RefreshTrigger, OpenTrigger };
